import React, {useEffect, useState} from "react"
import ReactModal from 'react-modal'
import styles from "./cybersecurityoctsubnav.css"


const cybersecurityoctsubNav = ( { }) => {

    
    
    return (
        <section className="subnav" id="subNav">
            <div className="containfix">
                <a className="subNavButton" href="https://www.fedscoop.com/events/snglive/cybersecurity-oct/#Speakers">SPEAKERS</a>
                <a className="subNavButton" href="https://www.fedscoop.com/events/snglive/cybersecurity-oct/#Agenda">AGENDA</a>
                <a className="subNavButton" href="https://www.fedscoop.com/events/snglive/cybersecurity-oct/wrap-up">WRAP-UP</a>
            </div>
         </section>
    )
}

export default cybersecurityoctsubNav